import filesUploadStoreFactory from 'hooks/filesUploadStoreFactory';

const useRevenuesFilesUploadStore = filesUploadStoreFactory([
  'invoice',
  'credit-note',
]);

export default useRevenuesFilesUploadStore;
